import { analyticsMerkleIds } from "./browser/plugins/merkle/index.es.js";
import { v as v4, o as originalSourcePlugin } from "./analytics-plugin-original-source.browser.es-b315981a.js";
import { g as getCookieHandler } from "./cookieHandler-ac6954c1.js";
import { logger, setLogger } from "./utils/logger.es.js";
import { p as pkg } from "./package-d8e0711a.js";
const EH_EVENT_TIME = "eh_event_time";
const EH_PAGE_VIEW_ID = "eh_page_view_id";
const EH_PREVIOUS_PAGE_VIEW_ID = "eh_previous_page_view_id";
const EH_PAGE_NAME = "eh_page_name";
const PAGE_VIEW_ID = "page_view_id";
const TIME_SINCE_LAST_EVENT = "time_since_last_event";
const getSessionStorageData = (key) => window.sessionStorage.getItem(key);
const setSessionStorageData = (key, value) => window.sessionStorage.setItem(key, value);
const timeOnPage = (eventType, pageName) => {
  if (!eventType || !pageName) {
    return { [PAGE_VIEW_ID]: void 0, [TIME_SINCE_LAST_EVENT]: void 0 };
  }
  const eventTime = new Date(getSessionStorageData(EH_EVENT_TIME)) || null;
  const currentPageName = getSessionStorageData(EH_PAGE_NAME) || null;
  const pageId = getSessionStorageData(EH_PAGE_VIEW_ID) || null;
  let timeDifference;
  if (eventType === "page") {
    if (!pageId) {
      const newPageViewId = v4();
      setSessionStorageData(EH_EVENT_TIME, /* @__PURE__ */ new Date());
      setSessionStorageData(EH_PAGE_VIEW_ID, newPageViewId);
      setSessionStorageData(EH_PAGE_NAME, pageName);
      return {
        [PAGE_VIEW_ID]: newPageViewId,
        [TIME_SINCE_LAST_EVENT]: 0
      };
    } else {
      const currentTime = /* @__PURE__ */ new Date();
      timeDifference = timeCalculation(currentTime, eventTime);
      setSessionStorageData(EH_EVENT_TIME, currentTime);
      setSessionStorageData(EH_PAGE_NAME, pageName);
      if (pageName !== currentPageName) {
        setSessionStorageData(EH_PAGE_VIEW_ID, v4());
        setSessionStorageData(EH_PREVIOUS_PAGE_VIEW_ID, pageId);
      }
      return {
        [PAGE_VIEW_ID]: pageId,
        [TIME_SINCE_LAST_EVENT]: timeDifference
      };
    }
  } else {
    if (pageName !== currentPageName) {
      const newPageId = v4();
      setSessionStorageData(EH_PAGE_NAME, pageName);
      setSessionStorageData(EH_PAGE_VIEW_ID, newPageId);
      const currentTime2 = /* @__PURE__ */ new Date();
      timeDifference = timeCalculation(currentTime2, eventTime);
      return {
        [PAGE_VIEW_ID]: newPageId,
        [TIME_SINCE_LAST_EVENT]: timeDifference
      };
    }
    const currentTime = /* @__PURE__ */ new Date();
    timeDifference = timeCalculation(currentTime, eventTime);
    setSessionStorageData(EH_EVENT_TIME, currentTime);
    return {
      [PAGE_VIEW_ID]: pageId,
      [TIME_SINCE_LAST_EVENT]: timeDifference
    };
  }
};
const timeCalculation = (currentTime, eventTime) => {
  if (isNaN(currentTime.getTime()) || isNaN(eventTime.getTime())) {
    return void 0;
  }
  return parseInt(
    (Math.abs(currentTime.getTime() - eventTime.getTime()) / 1e3).toFixed(1),
    10
  );
};
const VISIT_ID = "visit_id";
const EH_VISIT_ID = "eh_visit_id";
const EH_VISIT_TS = "eh_visit_ts";
const URL_VISIT_IDS = "url_visit_ids";
const EH_PREVIOUS_VISIT_ID = "eh_previous_visit_id";
const timeThreshold = 30 * 60;
const longCookieExpiration = new Date(
  Date.now() + 1e3 * 60 * 60 * 24 * 365 * 10
);
const timeExpiredCheck = (timeDifference, visitId, cookieOptions, cookieHandler) => {
  if (timeDifference > timeThreshold) {
    const newVisitId = v4();
    cookieHandler.setCookie(
      {
        [EH_PREVIOUS_VISIT_ID]: visitId,
        [EH_VISIT_ID]: newVisitId
      },
      [{ ...cookieOptions, expires: longCookieExpiration }, cookieOptions]
    );
    return newVisitId;
  } else {
    return visitId;
  }
};
const processUrlVisitId = (cookies, urlVisitId, cookieOptions, cookieHandler) => {
  try {
    const currentTime = /* @__PURE__ */ new Date();
    const urlVisitIdsArr = JSON.parse(cookies[URL_VISIT_IDS] || null) || [];
    if (urlVisitIdsArr.includes(urlVisitId)) {
      const ehVisitIdSetTime = new Date(cookies[EH_VISIT_TS]) || null;
      const timeDifference = timeCalculation(currentTime, ehVisitIdSetTime);
      cookieHandler.setCookie({ [EH_VISIT_TS]: /* @__PURE__ */ new Date() }, [cookieOptions]);
      if (urlVisitId === cookies[URL_VISIT_IDS][0]) {
        return timeExpiredCheck(
          timeDifference,
          urlVisitId,
          cookieOptions,
          cookieHandler
        );
      } else {
        const visitId = cookies[EH_VISIT_ID];
        return timeExpiredCheck(
          timeDifference,
          visitId,
          cookieOptions,
          cookieHandler
        );
      }
    } else {
      urlVisitIdsArr.unshift(urlVisitId);
      cookieHandler.setCookie(
        {
          [EH_VISIT_ID]: urlVisitId,
          [EH_VISIT_TS]: currentTime,
          [URL_VISIT_IDS]: JSON.stringify(urlVisitIdsArr)
        },
        [cookieOptions, cookieOptions, cookieOptions]
      );
      return urlVisitId;
    }
  } catch (error) {
    logger.error(`Error parsing URL Paramater ${error}`);
  }
};
const getUrlVisitId = () => {
  let urlVisitId = null;
  if (typeof window !== "undefined") {
    const urlParams = new URLSearchParams(window.location.search);
    urlVisitId = urlParams.get(VISIT_ID);
    if (urlVisitId) {
      const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
      if (!uuidRegex.test(urlVisitId)) {
        logger.error("Invalid URL VisitId format");
        urlVisitId = null;
      }
    }
    if (urlVisitId === "undefined") {
      logger.error("URL VisitId is `undefined`");
      urlVisitId = null;
    }
  }
  return urlVisitId;
};
const getVisitId = (adapter) => {
  try {
    const cookieHandler = getCookieHandler(adapter);
    const urlVisitId = getUrlVisitId();
    const cookieOptions = cookieHandler.getCookieOptions();
    const cookies = cookieHandler.parseCookies();
    const visitId = cookies[EH_VISIT_ID] || null;
    if (urlVisitId) {
      return processUrlVisitId(
        cookies,
        urlVisitId,
        cookieOptions,
        cookieHandler
      );
    } else if (visitId) {
      const currentTime = /* @__PURE__ */ new Date();
      const visitIdSetTime = new Date(cookies[EH_VISIT_TS]) || null;
      const timeDifference = timeCalculation(currentTime, visitIdSetTime);
      cookieHandler.setCookie({ [EH_VISIT_TS]: /* @__PURE__ */ new Date() }, [cookieOptions]);
      return timeExpiredCheck(
        timeDifference,
        visitId,
        cookieOptions,
        cookieHandler
      );
    } else {
      const firstVisitId = v4();
      cookieHandler.setCookie(
        {
          [EH_VISIT_ID]: firstVisitId,
          [EH_VISIT_TS]: /* @__PURE__ */ new Date()
        },
        [cookieOptions, cookieOptions]
      );
      return firstVisitId;
    }
  } catch (error) {
    logger.error("Error getting Visit Id", error);
  }
};
function i$3(t2, e2, l2, n2, r2) {
  for (e2 = e2.split ? e2.split(".") : e2, n2 = 0; n2 < e2.length; n2++)
    t2 = t2 ? t2[e2[n2]] : r2;
  return t2 === r2 ? l2 : t2;
}
var F$4 = "undefined" != typeof process ? process : {};
F$4.env && F$4.env.NODE_ENV || "";
var $$3 = "undefined" != typeof document;
null != F$4.versions && null != F$4.versions.node;
"undefined" != typeof Deno && void 0 !== Deno.core;
$$3 && "nodejs" === window.name || "undefined" != typeof navigator && void 0 !== navigator.userAgent && (navigator.userAgent.includes("Node.js") || navigator.userAgent.includes("jsdom"));
function M$3(n2, t2) {
  return t2.charAt(0)[n2]() + t2.slice(1);
}
var U$3 = M$3.bind(null, "toUpperCase"), H$3 = M$3.bind(null, "toLowerCase");
function J$4(n2) {
  return Y$3(n2) ? U$3("null") : "object" == typeof n2 ? yn$2(n2) : Object.prototype.toString.call(n2).slice(8, -1);
}
function R$3(n2, t2) {
  void 0 === t2 && (t2 = true);
  var e2 = J$4(n2);
  return t2 ? H$3(e2) : e2;
}
function V$3(n2, t2) {
  return typeof t2 === n2;
}
var W$3 = V$3.bind(null, "function"), q$3 = V$3.bind(null, "string");
V$3.bind(null, "undefined");
V$3.bind(null, "boolean");
V$3.bind(null, "symbol");
function Y$3(n2) {
  return null === n2;
}
function nn$2(n2) {
  return "number" === R$3(n2) && !isNaN(n2);
}
function yn$2(n2) {
  return W$3(n2.constructor) ? n2.constructor.name : null;
}
function hn$2(n2) {
  return n2 instanceof Error || q$3(n2.message) && n2.constructor && nn$2(n2.constructor.stackTraceLimit);
}
function On$2(n2, t2) {
  if ("object" != typeof t2 || Y$3(t2))
    return false;
  if (t2 instanceof n2)
    return true;
  var e2 = R$3(new n2(""));
  if (hn$2(t2))
    for (; t2; ) {
      if (R$3(t2) === e2)
        return true;
      t2 = Object.getPrototypeOf(t2);
    }
  return false;
}
On$2.bind(null, TypeError);
On$2.bind(null, SyntaxError);
function $n$2(n2, t2) {
  var e2 = n2 instanceof Element || n2 instanceof HTMLDocument;
  return e2 && t2 ? Tn$2(n2, t2) : e2;
}
function Tn$2(n2, t2) {
  return void 0 === t2 && (t2 = ""), n2 && n2.nodeName === t2.toUpperCase();
}
function _n$2(n2) {
  var t2 = [].slice.call(arguments, 1);
  return function() {
    return n2.apply(void 0, [].slice.call(arguments).concat(t2));
  };
}
_n$2($n$2, "form");
_n$2($n$2, "button");
_n$2($n$2, "input");
_n$2($n$2, "select");
function n$1(e2) {
  try {
    return decodeURIComponent(e2.replace(/\+/g, " "));
  } catch (e3) {
    return null;
  }
}
function o$2() {
  if ($$3) {
    var r2 = navigator, t2 = r2.languages;
    return r2.userLanguage || (t2 && t2.length ? t2[0] : r2.language);
  }
}
function a$3() {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch (e2) {
  }
}
function s(r2) {
  return function(e2) {
    for (var r3, t2 = /* @__PURE__ */ Object.create(null), o2 = /([^&=]+)=?([^&]*)/g; r3 = o2.exec(e2); ) {
      var a2 = n$1(r3[1]), i2 = n$1(r3[2]);
      "[]" === a2.substring(a2.length - 2) ? (t2[a2 = a2.substring(0, a2.length - 2)] || (t2[a2] = [])).push(i2) : t2[a2] = "" === i2 || i2;
    }
    for (var u2 in t2) {
      var c2 = u2.split("[");
      c2.length > 1 && (m$1(t2, c2.map(function(e3) {
        return e3.replace(/[?[\]\\ ]/g, "");
      }), t2[u2]), delete t2[u2]);
    }
    return t2;
  }(function(r3) {
    if (r3) {
      var t2 = r3.match(/\?(.*)/);
      return t2 && t2[1] ? t2[1].split("#")[0] : "";
    }
    return $$3 && window.location.search.substring(1);
  }(r2));
}
function m$1(e2, r2, t2) {
  for (var n2 = r2.length - 1, o2 = 0; o2 < n2; ++o2) {
    var a2 = r2[o2];
    if ("__proto__" === a2 || "constructor" === a2)
      break;
    a2 in e2 || (e2[a2] = {}), e2 = e2[a2];
  }
  e2[r2[n2]] = t2;
}
function y$1() {
  for (var e2 = "", r2 = 0, t2 = 4294967295 * Math.random() | 0; r2++ < 36; ) {
    var n2 = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx"[r2 - 1], o2 = 15 & t2;
    e2 += "-" == n2 || "4" == n2 ? n2 : ("x" == n2 ? o2 : 3 & o2 | 8).toString(16), t2 = r2 % 8 == 0 ? 4294967295 * Math.random() | 0 : t2 >> 4;
  }
  return e2;
}
var e = "undefined", o$1 = "object", j$1 = "__", F$3 = "undefined" != typeof process ? process : {};
F$3.env && F$3.env.NODE_ENV || "";
var $$2 = "undefined" != typeof document;
null != F$3.versions && null != F$3.versions.node;
"undefined" != typeof Deno && void 0 !== Deno.core;
$$2 && "nodejs" === window.name || "undefined" != typeof navigator && void 0 !== navigator.userAgent && (navigator.userAgent.includes("Node.js") || navigator.userAgent.includes("jsdom"));
function M$2(n2, t2) {
  return t2.charAt(0)[n2]() + t2.slice(1);
}
var U$2 = M$2.bind(null, "toUpperCase"), H$2 = M$2.bind(null, "toLowerCase");
function J$3(n2) {
  return Y$2(n2) ? U$2("null") : "object" == typeof n2 ? yn$1(n2) : Object.prototype.toString.call(n2).slice(8, -1);
}
function R$2(n2, t2) {
  void 0 === t2 && (t2 = true);
  var e2 = J$3(n2);
  return t2 ? H$2(e2) : e2;
}
function V$2(n2, t2) {
  return typeof t2 === n2;
}
var W$2 = V$2.bind(null, "function"), q$2 = V$2.bind(null, "string");
V$2.bind(null, "undefined");
V$2.bind(null, "boolean");
V$2.bind(null, "symbol");
function Y$2(n2) {
  return null === n2;
}
function nn$1(n2) {
  return "number" === R$2(n2) && !isNaN(n2);
}
function yn$1(n2) {
  return W$2(n2.constructor) ? n2.constructor.name : null;
}
function hn$1(n2) {
  return n2 instanceof Error || q$2(n2.message) && n2.constructor && nn$1(n2.constructor.stackTraceLimit);
}
function On$1(n2, t2) {
  if ("object" != typeof t2 || Y$2(t2))
    return false;
  if (t2 instanceof n2)
    return true;
  var e2 = R$2(new n2(""));
  if (hn$1(t2))
    for (; t2; ) {
      if (R$2(t2) === e2)
        return true;
      t2 = Object.getPrototypeOf(t2);
    }
  return false;
}
On$1.bind(null, TypeError);
On$1.bind(null, SyntaxError);
function $n$1(n2, t2) {
  var e2 = n2 instanceof Element || n2 instanceof HTMLDocument;
  return e2 && t2 ? Tn$1(n2, t2) : e2;
}
function Tn$1(n2, t2) {
  return void 0 === t2 && (t2 = ""), n2 && n2.nodeName === t2.toUpperCase();
}
function _n$1(n2) {
  var t2 = [].slice.call(arguments, 1);
  return function() {
    return n2.apply(void 0, [].slice.call(arguments).concat(t2));
  };
}
_n$1($n$1, "form");
_n$1($n$1, "button");
_n$1($n$1, "input");
_n$1($n$1, "select");
var l = "global", o = j$1 + "global" + j$1, n = typeof self === o$1 && self.self === self && self || typeof global === o$1 && global.global === global && global || void 0;
function a$2(t2) {
  return n[o][t2];
}
function f(t2, e2) {
  return n[o][t2] = e2;
}
function i$2(t2) {
  delete n[o][t2];
}
function u$1(t2, e2, r2) {
  var l2;
  try {
    if (b$3(t2)) {
      var o2 = window[t2];
      l2 = o2[e2].bind(o2);
    }
  } catch (t3) {
  }
  return l2 || r2;
}
n[o] || (n[o] = {});
var c$1 = {};
function b$3(t2) {
  if (typeof c$1[t2] !== e)
    return c$1[t2];
  try {
    var e$1 = window[t2];
    e$1.setItem(e, e), e$1.removeItem(e);
  } catch (e2) {
    return c$1[t2] = false;
  }
  return c$1[t2] = true;
}
var b$2 = "any", m = "*", j = "__", F$2 = "undefined" != typeof process ? process : {};
F$2.env && F$2.env.NODE_ENV || "";
var $$1 = "undefined" != typeof document;
null != F$2.versions && null != F$2.versions.node;
"undefined" != typeof Deno && void 0 !== Deno.core;
$$1 && "nodejs" === window.name || "undefined" != typeof navigator && void 0 !== navigator.userAgent && (navigator.userAgent.includes("Node.js") || navigator.userAgent.includes("jsdom"));
function M$1(n2, t2) {
  return t2.charAt(0)[n2]() + t2.slice(1);
}
var U$1 = M$1.bind(null, "toUpperCase"), H$1 = M$1.bind(null, "toLowerCase");
function J$2(n2) {
  return Y$1(n2) ? U$1("null") : "object" == typeof n2 ? yn(n2) : Object.prototype.toString.call(n2).slice(8, -1);
}
function R$1(n2, t2) {
  void 0 === t2 && (t2 = true);
  var e2 = J$2(n2);
  return t2 ? H$1(e2) : e2;
}
function V$1(n2, t2) {
  return typeof t2 === n2;
}
var W$1 = V$1.bind(null, "function"), q$1 = V$1.bind(null, "string"), I$2 = V$1.bind(null, "undefined");
var Q$1 = V$1.bind(null, "boolean");
V$1.bind(null, "symbol");
function Y$1(n2) {
  return null === n2;
}
function nn(n2) {
  return "number" === R$1(n2) && !isNaN(n2);
}
function rn(n2) {
  return "array" === R$1(n2);
}
function on(n2) {
  if (!un(n2))
    return false;
  for (var t2 = n2; null !== Object.getPrototypeOf(t2); )
    t2 = Object.getPrototypeOf(t2);
  return Object.getPrototypeOf(n2) === t2;
}
function un(n2) {
  return n2 && ("object" == typeof n2 || null !== n2);
}
function yn(n2) {
  return W$1(n2.constructor) ? n2.constructor.name : null;
}
function hn(n2) {
  return n2 instanceof Error || q$1(n2.message) && n2.constructor && nn(n2.constructor.stackTraceLimit);
}
function On(n2, t2) {
  if ("object" != typeof t2 || Y$1(t2))
    return false;
  if (t2 instanceof n2)
    return true;
  var e2 = R$1(new n2(""));
  if (hn(t2))
    for (; t2; ) {
      if (R$1(t2) === e2)
        return true;
      t2 = Object.getPrototypeOf(t2);
    }
  return false;
}
On.bind(null, TypeError);
On.bind(null, SyntaxError);
function $n(n2, t2) {
  var e2 = n2 instanceof Element || n2 instanceof HTMLDocument;
  return e2 && t2 ? Tn(n2, t2) : e2;
}
function Tn(n2, t2) {
  return void 0 === t2 && (t2 = ""), n2 && n2.nodeName === t2.toUpperCase();
}
function _n(n2) {
  var t2 = [].slice.call(arguments, 1);
  return function() {
    return n2.apply(void 0, [].slice.call(arguments).concat(t2));
  };
}
_n($n, "form");
_n($n, "button");
_n($n, "input");
_n($n, "select");
function v() {
  return v = Object.assign || function(e2) {
    for (var n2 = 1; n2 < arguments.length; n2++) {
      var t2 = arguments[n2];
      for (var r2 in t2)
        Object.prototype.hasOwnProperty.call(t2, r2) && (e2[r2] = t2[r2]);
    }
    return e2;
  }, v.apply(this, arguments);
}
var y = "function", b$1 = "undefined", I$1 = "@@redux/" + Math.random().toString(36), w = /* @__PURE__ */ function() {
  return typeof Symbol === y && Symbol.observable || "@@observable";
}(), E$1 = " != " + y;
function P(e2, n2, t2) {
  var r2;
  if (typeof n2 === y && typeof t2 === b$1 && (t2 = n2, n2 = void 0), typeof t2 !== b$1) {
    if (typeof t2 !== y)
      throw new Error("enhancer" + E$1);
    return t2(P)(e2, n2);
  }
  if (typeof e2 !== y)
    throw new Error("reducer" + E$1);
  var i2 = e2, a2 = n2, o2 = [], u2 = o2, c2 = false;
  function s2() {
    u2 === o2 && (u2 = o2.slice());
  }
  function f2() {
    return a2;
  }
  function d2(e3) {
    if (typeof e3 !== y)
      throw new Error("Listener" + E$1);
    var n3 = true;
    return s2(), u2.push(e3), function() {
      if (n3) {
        n3 = false, s2();
        var t3 = u2.indexOf(e3);
        u2.splice(t3, 1);
      }
    };
  }
  function p(e3) {
    if (!on(e3))
      throw new Error("Act != obj");
    if (typeof e3.type === b$1)
      throw new Error("ActType " + b$1);
    if (c2)
      throw new Error("Dispatch in reducer");
    try {
      c2 = true, a2 = i2(a2, e3);
    } finally {
      c2 = false;
    }
    for (var n3 = o2 = u2, t3 = 0; t3 < n3.length; t3++)
      (0, n3[t3])();
    return e3;
  }
  return p({ type: "@@redux/INIT" }), (r2 = { dispatch: p, subscribe: d2, getState: f2, replaceReducer: function(e3) {
    if (typeof e3 !== y)
      throw new Error("next reducer" + E$1);
    i2 = e3, p({ type: "@@redux/INIT" });
  } })[w] = function() {
    var e3, n3 = d2;
    return (e3 = { subscribe: function(e4) {
      if ("object" != typeof e4)
        throw new TypeError("Observer != obj");
      function t3() {
        e4.next && e4.next(f2());
      }
      return t3(), { unsubscribe: n3(t3) };
    } })[w] = function() {
      return this;
    }, e3;
  }, r2;
}
function S(e2, n2) {
  var t2 = n2 && n2.type;
  return "action " + (t2 && t2.toString() || "?") + "reducer " + e2 + " returns " + b$1;
}
function N$1() {
  var e2 = [].slice.call(arguments);
  return 0 === e2.length ? function(e3) {
    return e3;
  } : 1 === e2.length ? e2[0] : e2.reduce(function(e3, n2) {
    return function() {
      return e3(n2.apply(void 0, [].slice.call(arguments)));
    };
  });
}
function O$1() {
  var e2 = arguments;
  return function(n2) {
    return function(t2, r2, i2) {
      var a2, o2 = n2(t2, r2, i2), u2 = o2.dispatch, c2 = { getState: o2.getState, dispatch: function(e3) {
        return u2(e3);
      } };
      return a2 = [].slice.call(e2).map(function(e3) {
        return e3(c2);
      }), v({}, o2, { dispatch: u2 = N$1.apply(void 0, a2)(o2.dispatch) });
    };
  };
}
var A$1 = j + "anon_id", _ = j + "user_id", x$1 = j + "user_traits", k$1 = "userId", T = "anonymousId", z = ["bootstrap", "params", "campaign", "initializeStart", "initialize", "initializeEnd", "ready", "resetStart", "reset", "resetEnd", "pageStart", "page", "pageEnd", "pageAborted", "trackStart", "track", "trackEnd", "trackAborted", "identifyStart", "identify", "identifyEnd", "identifyAborted", "userIdChanged", "registerPlugins", "enablePlugin", "disablePlugin", "online", "offline", "setItemStart", "setItem", "setItemEnd", "setItemAborted", "removeItemStart", "removeItem", "removeItemEnd", "removeItemAborted"], M = ["name", "EVENTS", "config", "loaded"], q = z.reduce(function(e2, n2) {
  return e2[n2] = n2, e2;
}, { registerPluginType: function(e2) {
  return "registerPlugin:" + e2;
}, pluginReadyType: function(e2) {
  return "ready:" + e2;
} }), U = /^utm_/, V = /^an_prop_/, L$1 = /^an_trait_/;
function C$1(e2) {
  var n2 = e2.storage.setItem;
  return function(t2) {
    return function(r2) {
      return function(i2) {
        if (i2.type === q.bootstrap) {
          var a2 = i2.params, o2 = i2.user, u2 = i2.persistedUser, c2 = i2.initialUser, s2 = u2.userId === o2.userId;
          u2.anonymousId !== o2.anonymousId && n2(A$1, o2.anonymousId), s2 || n2(_, o2.userId), c2.traits && n2(x$1, v({}, s2 && u2.traits ? u2.traits : {}, c2.traits));
          var l2 = Object.keys(i2.params);
          if (l2.length) {
            var f2 = a2.an_uid, d2 = a2.an_event, p = l2.reduce(function(e3, n3) {
              if (n3.match(U) || n3.match(/^(d|g)clid/)) {
                var t3 = n3.replace(U, "");
                e3.campaign["campaign" === t3 ? "name" : t3] = a2[n3];
              }
              return n3.match(V) && (e3.props[n3.replace(V, "")] = a2[n3]), n3.match(L$1) && (e3.traits[n3.replace(L$1, "")] = a2[n3]), e3;
            }, { campaign: {}, props: {}, traits: {} });
            t2.dispatch(v({ type: q.params, raw: a2 }, p, f2 ? { userId: f2 } : {})), f2 && setTimeout(function() {
              return e2.identify(f2, p.traits);
            }, 0), d2 && setTimeout(function() {
              return e2.track(d2, p.props);
            }, 0), Object.keys(p.campaign).length && t2.dispatch({ type: q.campaign, campaign: p.campaign });
          }
        }
        return r2(i2);
      };
    };
  };
}
function R(e2) {
  return function(n2, t2) {
    if (void 0 === n2 && (n2 = {}), void 0 === t2 && (t2 = {}), t2.type === q.setItemEnd) {
      if (t2.key === A$1)
        return v({}, n2, { anonymousId: t2.value });
      if (t2.key === _)
        return v({}, n2, { userId: t2.value });
    }
    switch (t2.type) {
      case q.identify:
        return Object.assign({}, n2, { userId: t2.userId, traits: v({}, n2.traits, t2.traits) });
      case q.reset:
        return [_, A$1, x$1].forEach(function(n3) {
          e2.removeItem(n3);
        }), Object.assign({}, n2, { userId: null, anonymousId: null, traits: {} });
      default:
        return n2;
    }
  };
}
function $(e2) {
  return { userId: e2.getItem(_), anonymousId: e2.getItem(A$1), traits: e2.getItem(x$1) };
}
var D = function(e2) {
  return j + "TEMP" + j + e2;
};
function B(n2) {
  var t2 = n2.storage, r2 = t2.setItem, i2 = t2.removeItem, a2 = t2.getItem;
  return function(n3) {
    return function(t3) {
      return function(u2) {
        var c2 = u2.userId, s2 = u2.traits, l2 = u2.options;
        if (u2.type === q.reset && ([_, x$1, A$1].forEach(function(e2) {
          i2(e2);
        }), [k$1, T, "traits"].forEach(function(e2) {
          i$2(D(e2));
        })), u2.type === q.identify) {
          a2(A$1) || r2(A$1, y$1());
          var f2 = a2(_), d2 = a2(x$1) || {};
          f2 && f2 !== c2 && n3.dispatch({ type: q.userIdChanged, old: { userId: f2, traits: d2 }, new: { userId: c2, traits: s2 }, options: l2 }), c2 && r2(_, c2), s2 && r2(x$1, v({}, d2, s2));
        }
        return t3(u2);
      };
    };
  };
}
var X = {};
function J$1(e2, n2) {
  X[e2] && W$1(X[e2]) && (X[e2](n2), delete X[e2]);
}
function W(e2, n2, t2) {
  return new Promise(function(r2, i2) {
    return n2() ? r2(e2) : t2 < 1 ? i2(v({}, e2, { queue: true })) : new Promise(function(e3) {
      return setTimeout(e3, 10);
    }).then(function(a2) {
      return W(e2, n2, t2 - 10).then(r2, i2);
    });
  });
}
function H(e2) {
  return { abort: e2 };
}
function F$1(e2, n2, t2) {
  var r2 = {}, i2 = n2(), a2 = e2.getState(), o2 = a2.plugins, u2 = a2.queue, c2 = a2.user;
  if (!a2.context.offline && u2 && u2.actions && u2.actions.length) {
    var s2 = u2.actions.reduce(function(e3, n3, t3) {
      return o2[n3.plugin].loaded ? (e3.process.push(n3), e3.processIndex.push(t3)) : (e3.requeue.push(n3), e3.requeueIndex.push(t3)), e3;
    }, { processIndex: [], process: [], requeue: [], requeueIndex: [] });
    if (s2.processIndex && s2.processIndex.length) {
      s2.processIndex.forEach(function(n3) {
        var a3 = u2.actions[n3], s3 = a3.plugin, f3 = a3.payload.type, p = i2[s3][f3];
        if (p && W$1(p)) {
          var m2, g2 = function(e3, n4) {
            return void 0 === e3 && (e3 = {}), void 0 === n4 && (n4 = {}), [k$1, T].reduce(function(t3, r3) {
              return e3.hasOwnProperty(r3) && n4[r3] && n4[r3] !== e3[r3] && (t3[r3] = n4[r3]), t3;
            }, e3);
          }(a3.payload, c2), h2 = r2[g2.meta.rid];
          if (!h2 && (m2 = p({ payload: g2, config: o2[s3].config, instance: t2, abort: H })) && on(m2) && m2.abort)
            return void (r2[g2.meta.rid] = true);
          if (!h2) {
            var y2 = f3 + ":" + s3;
            e2.dispatch(v({}, g2, { type: y2, _: { called: y2, from: "queueDrain" } }));
          }
        }
      });
      var f2 = u2.actions.filter(function(e3, n3) {
        return !~s2.processIndex.indexOf(n3);
      });
      u2.actions = f2;
    }
  }
}
var G$1 = function(e2) {
  var n2 = e2.data, t2 = e2.action, r2 = e2.instance, i2 = e2.state, a2 = e2.allPlugins, o2 = e2.allMatches, u2 = e2.store, c2 = e2.EVENTS;
  try {
    var s2 = i2.plugins, f2 = i2.context, p = t2.type, m2 = p.match(K), g2 = n2.exact.map(function(e3) {
      return e3.pluginName;
    });
    m2 && (g2 = o2.during.map(function(e3) {
      return e3.pluginName;
    }));
    var h2 = function(e3, n3) {
      return function(t3, r3, i3) {
        var a3 = r3.config, o3 = r3.name, u3 = o3 + "." + t3.type;
        i3 && (u3 = i3.event);
        var c3 = t3.type.match(K) ? function(e4, n4, t4, r4, i4) {
          return function(a4, o4) {
            var u4 = r4 ? r4.name : e4, c4 = o4 && ae(o4) ? o4 : t4;
            if (r4 && (!(c4 = o4 && ae(o4) ? o4 : [e4]).includes(e4) || 1 !== c4.length))
              throw new Error("Method " + n4 + " can only abort " + e4 + " plugin. " + JSON.stringify(c4) + " input valid");
            return v({}, i4, { abort: { reason: a4, plugins: c4, caller: n4, _: u4 } });
          };
        }(o3, u3, n3, i3, t3) : function(e4, n4) {
          return function() {
            throw new Error(e4.type + " action not cancellable. Remove abort in " + n4);
          };
        }(t3, u3);
        return { payload: ce(t3), instance: e3, config: a3 || {}, abort: c3 };
      };
    }(r2, g2), y2 = n2.exact.reduce(function(e3, n3) {
      var t3 = n3.pluginName, r3 = n3.methodName, i3 = false;
      return r3.match(/^initialize/) || r3.match(/^reset/) || (i3 = !s2[t3].loaded), f2.offline && r3.match(/^(page|track|identify)/) && (i3 = true), e3["" + t3] = i3, e3;
    }, {});
    return Promise.resolve(n2.exact.reduce(function(e3, i3, o3) {
      try {
        var u3 = i3.pluginName;
        return Promise.resolve(e3).then(function(e4) {
          function i4() {
            return Promise.resolve(e4);
          }
          var o4 = function() {
            if (n2.namespaced && n2.namespaced[u3])
              return Promise.resolve(n2.namespaced[u3].reduce(function(e5, n3, t3) {
                try {
                  return Promise.resolve(e5).then(function(e6) {
                    return n3.method && W$1(n3.method) ? (function(e7, n4) {
                      var t5 = ue(e7);
                      if (t5 && t5.name === n4) {
                        var r3 = ue(t5.method);
                        throw new Error([n4 + " plugin is calling method " + e7, "Plugins cant call self", "Use " + t5.method + " " + (r3 ? "or " + r3.method : "") + " in " + n4 + " plugin insteadof " + e7].join("\n"));
                      }
                    }(n3.methodName, n3.pluginName), Promise.resolve(n3.method({ payload: e6, instance: r2, abort: (t4 = e6, i5 = u3, o5 = n3.pluginName, function(e7, n4) {
                      return v({}, t4, { abort: { reason: e7, plugins: n4 || [i5], caller: p, from: o5 || i5 } });
                    }), config: ee(n3.pluginName, s2, a2), plugins: s2 })).then(function(n4) {
                      var t5 = on(n4) ? n4 : {};
                      return Promise.resolve(v({}, e6, t5));
                    })) : e6;
                    var t4, i5, o5;
                  });
                } catch (e6) {
                  return Promise.reject(e6);
                }
              }, Promise.resolve(t2))).then(function(n3) {
                e4[u3] = n3;
              });
            e4[u3] = t2;
          }();
          return o4 && o4.then ? o4.then(i4) : i4();
        });
      } catch (e4) {
        return Promise.reject(e4);
      }
    }, Promise.resolve({}))).then(function(e3) {
      return Promise.resolve(n2.exact.reduce(function(t3, i3, o3) {
        try {
          var c3 = n2.exact.length === o3 + 1, f3 = i3.pluginName, d2 = a2[f3];
          return Promise.resolve(t3).then(function(n3) {
            var t4 = e3[f3] ? e3[f3] : {};
            if (m2 && (t4 = n3), re(t4, f3))
              return Z({ data: t4, method: p, instance: r2, pluginName: f3, store: u2 }), Promise.resolve(n3);
            if (re(n3, f3))
              return c3 && Z({ data: n3, method: p, instance: r2, store: u2 }), Promise.resolve(n3);
            if (y2.hasOwnProperty(f3) && true === y2[f3])
              return u2.dispatch({ type: "queue", plugin: f3, payload: t4, _: { called: "queue", from: "queueMechanism" } }), Promise.resolve(n3);
            var i4 = h2(e3[f3], a2[f3]);
            return Promise.resolve(d2[p]({ abort: i4.abort, payload: t4, instance: r2, config: ee(f3, s2, a2), plugins: s2 })).then(function(i5) {
              var a3 = on(i5) ? i5 : {}, o4 = v({}, n3, a3), c4 = e3[f3];
              if (re(c4, f3))
                Z({ data: c4, method: p, instance: r2, pluginName: f3, store: u2 });
              else {
                var s3 = p + ":" + f3;
                (s3.match(/:/g) || []).length < 2 && !p.match(Q) && !p.match(Y) && r2.dispatch(v({}, m2 ? o4 : t4, { type: s3, _: { called: s3, from: "submethod" } }));
              }
              return Promise.resolve(o4);
            });
          });
        } catch (e4) {
          return Promise.reject(e4);
        }
      }, Promise.resolve(t2))).then(function(e4) {
        if (!(p.match(K) || p.match(/^registerPlugin/) || p.match(Y) || p.match(Q) || p.match(/^params/) || p.match(/^userIdChanged/))) {
          if (c2.plugins.includes(p), e4._ && e4._.originalAction === p)
            return e4;
          var t3 = v({}, e4, { _: { originalAction: e4.type, called: e4.type, from: "engineEnd" } });
          ie(e4, n2.exact.length) && !p.match(/End$/) && (t3 = v({}, t3, { type: e4.type + "Aborted" })), u2.dispatch(t3);
        }
        return e4;
      });
    });
  } catch (e3) {
    return Promise.reject(e3);
  }
}, K = /Start$/, Q = /^bootstrap/, Y = /^ready/;
function Z(e2) {
  var n2 = e2.pluginName, t2 = e2.method + "Aborted" + (n2 ? ":" + n2 : "");
  e2.store.dispatch(v({}, e2.data, { type: t2, _: { called: t2, from: "abort" } }));
}
function ee(e2, n2, t2) {
  var r2 = n2[e2] || t2[e2];
  return r2 && r2.config ? r2.config : {};
}
function ne(e2, n2) {
  return n2.reduce(function(n3, t2) {
    return t2[e2] ? n3.concat({ methodName: e2, pluginName: t2.name, method: t2[e2] }) : n3;
  }, []);
}
function te(e2, n2) {
  var t2 = e2.replace(K, ""), r2 = n2 ? ":" + n2 : "";
  return ["" + e2 + r2, "" + t2 + r2, t2 + "End" + r2];
}
function re(e2, n2) {
  var t2 = e2.abort;
  return !!t2 && (true === t2 || oe(t2, n2) || t2 && oe(t2.plugins, n2));
}
function ie(e2, n2) {
  var t2 = e2.abort;
  if (!t2)
    return false;
  if (true === t2 || q$1(t2))
    return true;
  var r2 = t2.plugins;
  return ae(t2) && t2.length === n2 || ae(r2) && r2.length === n2;
}
function ae(e2) {
  return Array.isArray(e2);
}
function oe(e2, n2) {
  return !(!e2 || !ae(e2)) && e2.includes(n2);
}
function ue(e2) {
  var n2 = e2.match(/(.*):(.*)/);
  return !!n2 && { method: n2[1], name: n2[2] };
}
function ce(e2) {
  return Object.keys(e2).reduce(function(n2, t2) {
    return "type" === t2 || (n2[t2] = on(e2[t2]) ? Object.assign({}, e2[t2]) : e2[t2]), n2;
  }, {});
}
function se(e2, n2, t2) {
  var r2 = {};
  return function(i2) {
    return function(a2) {
      return function(o2) {
        try {
          var u2, c2 = function(e3) {
            return u2 ? e3 : a2(f2);
          }, s2 = o2.type, l2 = o2.plugins, f2 = o2;
          if (o2.abort)
            return Promise.resolve(a2(o2));
          if (s2 === q.enablePlugin && i2.dispatch({ type: q.initializeStart, plugins: l2, disabled: [], fromEnable: true, meta: o2.meta }), s2 === q.disablePlugin && setTimeout(function() {
            return J$1(o2.meta.rid, { payload: o2 });
          }, 0), s2 === q.initializeEnd) {
            var m2 = n2(), g2 = Object.keys(m2), h2 = g2.filter(function(e3) {
              return l2.includes(e3);
            }).map(function(e3) {
              return m2[e3];
            }), y2 = [], b2 = [], I2 = o2.disabled, w2 = h2.map(function(e3) {
              var n3 = e3.loaded, t3 = e3.name, a3 = e3.config;
              return W(e3, function() {
                return n3({ config: a3 });
              }, 1e4).then(function(n4) {
                return r2[t3] || (i2.dispatch({ type: q.pluginReadyType(t3), name: t3, events: Object.keys(e3).filter(function(e4) {
                  return !M.includes(e4);
                }) }), r2[t3] = true), y2 = y2.concat(t3), e3;
              }).catch(function(e4) {
                if (e4 instanceof Error)
                  throw new Error(e4);
                return b2 = b2.concat(e4.name), e4;
              });
            });
            Promise.all(w2).then(function(e3) {
              var n3 = { plugins: y2, failed: b2, disabled: I2 };
              setTimeout(function() {
                g2.length === w2.length + I2.length && i2.dispatch(v({}, { type: q.ready }, n3));
              }, 0);
            });
          }
          var E2 = function() {
            if (s2 !== q.bootstrap)
              return /^ready:([^:]*)$/.test(s2) && setTimeout(function() {
                return F$1(i2, n2, e2);
              }, 0), Promise.resolve(function(e3, n3, t3, r3, i3) {
                try {
                  var a3 = W$1(n3) ? n3() : n3, o3 = e3.type, u3 = o3.replace(K, "");
                  if (e3._ && e3._.called)
                    return Promise.resolve(e3);
                  var c3 = t3.getState(), s3 = (m3 = a3, void 0 === (g3 = c3.plugins) && (g3 = {}), void 0 === (h3 = e3.options) && (h3 = {}), Object.keys(m3).filter(function(e4) {
                    var n4 = h3.plugins || {};
                    return Q$1(n4[e4]) ? n4[e4] : false !== n4.all && (!g3[e4] || false !== g3[e4].enabled);
                  }).map(function(e4) {
                    return m3[e4];
                  }));
                  o3 === q.initializeStart && e3.fromEnable && (s3 = Object.keys(c3.plugins).filter(function(n4) {
                    var t4 = c3.plugins[n4];
                    return e3.plugins.includes(n4) && !t4.initialized;
                  }).map(function(e4) {
                    return a3[e4];
                  }));
                  var l3 = s3.map(function(e4) {
                    return e4.name;
                  }), f3 = function(e4, n4, t4) {
                    var r4 = te(e4).map(function(e5) {
                      return ne(e5, n4);
                    });
                    return n4.reduce(function(t5, r5) {
                      var i4 = r5.name, a4 = te(e4, i4).map(function(e5) {
                        return ne(e5, n4);
                      }), o4 = a4[0], u4 = a4[1], c4 = a4[2];
                      return o4.length && (t5.beforeNS[i4] = o4), u4.length && (t5.duringNS[i4] = u4), c4.length && (t5.afterNS[i4] = c4), t5;
                    }, { before: r4[0], beforeNS: {}, during: r4[1], duringNS: {}, after: r4[2], afterNS: {} });
                  }(o3, s3);
                  return Promise.resolve(G$1({ action: e3, data: { exact: f3.before, namespaced: f3.beforeNS }, state: c3, allPlugins: a3, allMatches: f3, instance: t3, store: r3, EVENTS: i3 })).then(function(e4) {
                    function n4() {
                      var n5 = function() {
                        if (o3.match(K))
                          return Promise.resolve(G$1({ action: v({}, s4, { type: u3 + "End" }), data: { exact: f3.after, namespaced: f3.afterNS }, state: c3, allPlugins: a3, allMatches: f3, instance: t3, store: r3, EVENTS: i3 })).then(function(e5) {
                            e5.meta && e5.meta.hasCallback && J$1(e5.meta.rid, { payload: e5 });
                          });
                      }();
                      return n5 && n5.then ? n5.then(function() {
                        return e4;
                      }) : e4;
                    }
                    if (ie(e4, l3.length))
                      return e4;
                    var s4, d2 = function() {
                      if (o3 !== u3)
                        return Promise.resolve(G$1({ action: v({}, e4, { type: u3 }), data: { exact: f3.during, namespaced: f3.duringNS }, state: c3, allPlugins: a3, allMatches: f3, instance: t3, store: r3, EVENTS: i3 })).then(function(e5) {
                          s4 = e5;
                        });
                      s4 = e4;
                    }();
                    return d2 && d2.then ? d2.then(n4) : n4();
                  });
                } catch (e4) {
                  return Promise.reject(e4);
                }
                var m3, g3, h3;
              }(o2, n2, e2, i2, t2)).then(function(e3) {
                return u2 = 1, a2(e3);
              });
          }();
          return Promise.resolve(E2 && E2.then ? E2.then(c2) : c2(E2));
        } catch (e3) {
          return Promise.reject(e3);
        }
      };
    };
  };
}
function le(e2) {
  return function(n2) {
    return function(n3) {
      return function(t2) {
        var r2 = t2.type, i2 = t2.key, a2 = t2.value, o2 = t2.options;
        if (r2 === q.setItem || r2 === q.removeItem) {
          if (t2.abort)
            return n3(t2);
          r2 === q.setItem ? e2.setItem(i2, a2, o2) : e2.removeItem(i2, o2);
        }
        return n3(t2);
      };
    };
  };
}
var fe = function() {
  var e2 = this;
  this.before = [], this.after = [], this.addMiddleware = function(n2, t2) {
    e2[t2] = e2[t2].concat(n2);
  }, this.removeMiddleware = function(n2, t2) {
    var r2 = e2[t2].findIndex(function(e3) {
      return e3 === n2;
    });
    -1 !== r2 && (e2[t2] = [].concat(e2[t2].slice(0, r2), e2[t2].slice(r2 + 1)));
  }, this.dynamicMiddlewares = function(n2) {
    return function(t2) {
      return function(r2) {
        return function(i2) {
          var a2 = { getState: t2.getState, dispatch: function(e3) {
            return t2.dispatch(e3);
          } }, o2 = e2[n2].map(function(e3) {
            return e3(a2);
          });
          return N$1.apply(void 0, o2)(r2)(i2);
        };
      };
    };
  };
};
function de(e2) {
  return function(n2, t2) {
    void 0 === n2 && (n2 = {});
    var r2 = {};
    if ("initialize:aborted" === t2.type)
      return n2;
    if (/^registerPlugin:([^:]*)$/.test(t2.type)) {
      var i2 = pe(t2.type, "registerPlugin"), a2 = e2()[i2];
      if (!a2 || !i2)
        return n2;
      var o2 = t2.enabled, u2 = a2.config;
      return r2[i2] = { enabled: o2, initialized: !!o2 && Boolean(!a2.initialize), loaded: !!o2 && Boolean(a2.loaded({ config: u2 })), config: u2 }, v({}, n2, r2);
    }
    if (/^initialize:([^:]*)$/.test(t2.type)) {
      var c2 = pe(t2.type, q.initialize), s2 = e2()[c2];
      return s2 && c2 ? (r2[c2] = v({}, n2[c2], { initialized: true, loaded: Boolean(s2.loaded({ config: s2.config })) }), v({}, n2, r2)) : n2;
    }
    if (/^ready:([^:]*)$/.test(t2.type))
      return r2[t2.name] = v({}, n2[t2.name], { loaded: true }), v({}, n2, r2);
    switch (t2.type) {
      case q.disablePlugin:
        return v({}, n2, me(t2.plugins, false, n2));
      case q.enablePlugin:
        return v({}, n2, me(t2.plugins, true, n2));
      default:
        return n2;
    }
  };
}
function pe(e2, n2) {
  return e2.substring(n2.length + 1, e2.length);
}
function me(e2, n2, t2) {
  return e2.reduce(function(e3, r2) {
    return e3[r2] = v({}, t2[r2], { enabled: n2 }), e3;
  }, t2);
}
function ge(e2) {
  try {
    return JSON.parse(JSON.stringify(e2));
  } catch (e3) {
  }
  return e2;
}
var he = { last: {}, history: [] };
function ve(e2, n2) {
  void 0 === e2 && (e2 = he);
  var t2 = n2.options, r2 = n2.meta;
  if (n2.type === q.track) {
    var i2 = ge(v({ event: n2.event, properties: n2.properties }, Object.keys(t2).length && { options: t2 }, { meta: r2 }));
    return v({}, e2, { last: i2, history: e2.history.concat(i2) });
  }
  return e2;
}
var ye = { actions: [] };
function be(e2, n2) {
  void 0 === e2 && (e2 = ye);
  var t2 = n2.payload;
  switch (n2.type) {
    case "queue":
      var r2;
      return r2 = t2 && t2.type && t2.type === q.identify ? [n2].concat(e2.actions) : e2.actions.concat(n2), v({}, e2, { actions: r2 });
    case "dequeue":
      return [];
    default:
      return e2;
  }
}
var Ie = /#.*$/;
function we(e2) {
  var n2 = /(http[s]?:\/\/)?([^\/\s]+\/)(.*)/g.exec(e2);
  return "/" + (n2 && n2[3] ? n2[3].split("?")[0].replace(Ie, "") : "");
}
var Ee, Pe, Se, Ne, Oe = function(e2) {
  if (void 0 === e2 && (e2 = {}), !$$1)
    return e2;
  var n2 = document, t2 = n2.title, r2 = n2.referrer, i2 = window, a2 = i2.location, o2 = i2.innerWidth, u2 = i2.innerHeight, c2 = a2.hash, s2 = a2.search, l2 = function(e3) {
    var n3 = function() {
      if ($$1) {
        for (var e4, n4 = document.getElementsByTagName("link"), t3 = 0; e4 = n4[t3]; t3++)
          if ("canonical" === e4.getAttribute("rel"))
            return e4.getAttribute("href");
      }
    }();
    return n3 ? n3.match(/\?/) ? n3 : n3 + e3 : window.location.href.replace(Ie, "");
  }(s2), f2 = { title: t2, url: l2, path: we(l2), hash: c2, search: s2, width: o2, height: u2 };
  return r2 && "" !== r2 && (f2.referrer = r2), v({}, f2, e2);
}, Ae = { last: {}, history: [] };
function _e(e2, n2) {
  void 0 === e2 && (e2 = Ae);
  var t2 = n2.options;
  if (n2.type === q.page) {
    var r2 = ge(v({ properties: n2.properties, meta: n2.meta }, Object.keys(t2).length && { options: t2 }));
    return v({}, e2, { last: r2, history: e2.history.concat(r2) });
  }
  return e2;
}
Ee = function() {
  if (!$$1)
    return false;
  var e2 = navigator.appVersion;
  return ~e2.indexOf("Win") ? "Windows" : ~e2.indexOf("Mac") ? "MacOS" : ~e2.indexOf("X11") ? "UNIX" : ~e2.indexOf("Linux") ? "Linux" : "Unknown OS";
}(), Pe = $$1 ? document.referrer : null, Se = o$2(), Ne = a$3();
var xe = { initialized: false, sessionId: y$1(), app: null, version: null, debug: false, offline: !!$$1 && !navigator.onLine, os: { name: Ee }, userAgent: $$1 ? navigator.userAgent : "node", library: { name: "analytics", version: "0.12.14" }, timezone: Ne, locale: Se, campaign: {}, referrer: Pe };
function je(e2, n2) {
  void 0 === e2 && (e2 = xe);
  var t2 = e2.initialized, r2 = n2.campaign;
  switch (n2.type) {
    case q.campaign:
      return v({}, e2, { campaign: r2 });
    case q.offline:
      return v({}, e2, { offline: true });
    case q.online:
      return v({}, e2, { offline: false });
    default:
      return t2 ? e2 : v({}, xe, e2, { initialized: true });
  }
}
var ke = ["plugins", "reducers", "storage"];
function Te(e2, n2, t2) {
  if ($$1) {
    var r2 = window[(t2 ? "add" : "remove") + "EventListener"];
    e2.split(" ").forEach(function(e3) {
      r2(e3, n2);
    });
  }
}
function ze(e2) {
  var n2 = Te.bind(null, "online offline", function(n3) {
    return Promise.resolve(!navigator.onLine).then(e2);
  });
  return n2(true), function(e3) {
    return n2(false);
  };
}
function Me() {
  return f("analytics", []), function(e2) {
    return function(n$12, t2, r2) {
      var i2 = e2(n$12, t2, r2), a2 = i2.dispatch;
      return Object.assign(i2, { dispatch: function(e3) {
        return n[o].analytics.push(e3.action || e3), a2(e3);
      } });
    };
  };
}
function qe(e2) {
  return function() {
    return N$1(N$1.apply(null, arguments), Me());
  };
}
function Ue(e2) {
  return e2 ? rn(e2) ? e2 : [e2] : [];
}
function Ve(n2, t2, r2) {
  void 0 === n2 && (n2 = {});
  var i2, a2, o2 = y$1();
  return t2 && (X[o2] = (i2 = t2, a2 = function(e2) {
    for (var n3, t3 = e2 || Array.prototype.slice.call(arguments), r3 = 0; r3 < t3.length; r3++)
      if (W$1(t3[r3])) {
        n3 = t3[r3];
        break;
      }
    return n3;
  }(r2), function(e2) {
    a2 && a2(e2), i2(e2);
  })), v({}, n2, { rid: o2, ts: (/* @__PURE__ */ new Date()).getTime() }, t2 ? { hasCallback: true } : {});
}
function Le(n2) {
  void 0 === n2 && (n2 = {});
  var t2 = n2.reducers || {}, c2 = n2.initialUser || {}, s$1 = (n2.plugins || []).reduce(function(e2, n3) {
    if (W$1(n3))
      return e2.middlewares = e2.middlewares.concat(n3), e2;
    if (n3.NAMESPACE && (n3.name = n3.NAMESPACE), !n3.name)
      throw new Error("https://lytics.dev/errors/1");
    n3.config || (n3.config = {});
    var t3 = n3.EVENTS ? Object.keys(n3.EVENTS).map(function(e3) {
      return n3.EVENTS[e3];
    }) : [];
    e2.pluginEnabled[n3.name] = !(false === n3.enabled || false === n3.config.enabled), delete n3.enabled, n3.methods && (e2.methods[n3.name] = Object.keys(n3.methods).reduce(function(e3, t4) {
      var r3;
      return e3[t4] = (r3 = n3.methods[t4], function() {
        for (var e4 = Array.prototype.slice.call(arguments), n4 = new Array(r3.length), t5 = 0; t5 < e4.length; t5++)
          n4[t5] = e4[t5];
        return n4[n4.length] = Q2, r3.apply({ instance: Q2 }, n4);
      }), e3;
    }, {}), delete n3.methods);
    var r2 = Object.keys(n3).concat(t3), i2 = new Set(e2.events.concat(r2));
    if (e2.events = Array.from(i2), e2.pluginsArray = e2.pluginsArray.concat(n3), e2.plugins[n3.name])
      throw new Error(n3.name + "AlreadyLoaded");
    return e2.plugins[n3.name] = n3, e2.plugins[n3.name].loaded || (e2.plugins[n3.name].loaded = function() {
      return true;
    }), e2;
  }, { plugins: {}, pluginEnabled: {}, methods: {}, pluginsArray: [], middlewares: [], events: [] }), f$1 = n2.storage ? n2.storage : { getItem: a$2, setItem: f, removeItem: i$2 }, p = function(e2) {
    return function(n3, t3, r2) {
      return t3.getState("user")[n3] || (r2 && on(r2) && r2[n3] ? r2[n3] : $(e2)[n3] || a$2(D(n3)) || null);
    };
  }(f$1), h2 = s$1.plugins, w2 = s$1.events.filter(function(e2) {
    return !M.includes(e2);
  }).sort(), E2 = new Set(w2.concat(z).filter(function(e2) {
    return !M.includes(e2);
  })), _2 = Array.from(E2).sort(), x2 = function() {
    return h2;
  }, j2 = new fe(), U2 = j2.addMiddleware, V2 = j2.removeMiddleware, L2 = j2.dynamicMiddlewares, X2 = function() {
    throw new Error("Abort disabled inListener");
  }, J2 = s(), W2 = $(f$1), H2 = v({}, W2, c2, J2.an_uid ? { userId: J2.an_uid } : {}, J2.an_aid ? { anonymousId: J2.an_aid } : {});
  H2.anonymousId || (H2.anonymousId = y$1());
  var G2 = v({ enable: function(e2, n3) {
    return new Promise(function(t3) {
      ue2.dispatch({ type: q.enablePlugin, plugins: Ue(e2), _: { originalAction: q.enablePlugin } }, t3, [n3]);
    });
  }, disable: function(e2, n3) {
    return new Promise(function(t3) {
      ue2.dispatch({ type: q.disablePlugin, plugins: Ue(e2), _: { originalAction: q.disablePlugin } }, t3, [n3]);
    });
  } }, s$1.methods), K2 = false, Q2 = { identify: function(e2, n3, t3, r2) {
    try {
      var i2 = q$1(e2) ? e2 : null, a2 = on(e2) ? e2 : n3, o2 = t3 || {}, c3 = Q2.user();
      f(D(k$1), i2);
      var s2 = i2 || a2.userId || p(k$1, Q2, a2);
      return Promise.resolve(new Promise(function(e3) {
        ue2.dispatch(v({ type: q.identifyStart, userId: s2, traits: a2 || {}, options: o2, anonymousId: c3.anonymousId }, c3.id && c3.id !== i2 && { previousId: c3.id }), e3, [n3, t3, r2]);
      }));
    } catch (e3) {
      return Promise.reject(e3);
    }
  }, track: function(e2, n3, t3, r2) {
    try {
      var i2 = on(e2) ? e2.event : e2;
      if (!i2 || !q$1(i2))
        throw new Error("EventMissing");
      var a2 = on(e2) ? e2 : n3 || {}, o2 = on(t3) ? t3 : {};
      return Promise.resolve(new Promise(function(e3) {
        ue2.dispatch({ type: q.trackStart, event: i2, properties: a2, options: o2, userId: p(k$1, Q2, n3), anonymousId: p(T, Q2, n3) }, e3, [n3, t3, r2]);
      }));
    } catch (e3) {
      return Promise.reject(e3);
    }
  }, page: function(e2, n3, t3) {
    try {
      var r2 = on(e2) ? e2 : {}, i2 = on(n3) ? n3 : {};
      return Promise.resolve(new Promise(function(a2) {
        ue2.dispatch({ type: q.pageStart, properties: Oe(r2), options: i2, userId: p(k$1, Q2, r2), anonymousId: p(T, Q2, r2) }, a2, [e2, n3, t3]);
      }));
    } catch (e3) {
      return Promise.reject(e3);
    }
  }, user: function(e2) {
    if (e2 === k$1 || "id" === e2)
      return p(k$1, Q2);
    if (e2 === T || "anonId" === e2)
      return p(T, Q2);
    var n3 = Q2.getState("user");
    return e2 ? i$3(n3, e2) : n3;
  }, reset: function(e2) {
    return new Promise(function(n3) {
      ue2.dispatch({ type: q.resetStart }, n3, e2);
    });
  }, ready: function(e2) {
    return K2 && e2({ plugins: G2, instance: Q2 }), Q2.on(q.ready, function(n3) {
      e2(n3), K2 = true;
    });
  }, on: function(e2, n3) {
    if (!e2 || !W$1(n3))
      return false;
    if (e2 === q.bootstrap)
      throw new Error(".on disabled for " + e2);
    var t3 = /Start$|Start:/;
    if ("*" === e2) {
      var r2 = function(e3) {
        return function(e4) {
          return function(r3) {
            return r3.type.match(t3) && n3({ payload: r3, instance: Q2, plugins: h2 }), e4(r3);
          };
        };
      }, i2 = function(e3) {
        return function(e4) {
          return function(r3) {
            return r3.type.match(t3) || n3({ payload: r3, instance: Q2, plugins: h2 }), e4(r3);
          };
        };
      };
      return U2(r2, Ce), U2(i2, Re), function() {
        V2(r2, Ce), V2(i2, Re);
      };
    }
    var a2 = e2.match(t3) ? Ce : Re, o2 = function(t4) {
      return function(t5) {
        return function(r3) {
          return r3.type === e2 && n3({ payload: r3, instance: Q2, plugins: h2, abort: X2 }), t5(r3);
        };
      };
    };
    return U2(o2, a2), function() {
      return V2(o2, a2);
    };
  }, once: function(e2, n3) {
    if (!e2 || !W$1(n3))
      return false;
    if (e2 === q.bootstrap)
      throw new Error(".once disabled for " + e2);
    var t3 = Q2.on(e2, function(e3) {
      n3({ payload: e3.payload, instance: Q2, plugins: h2, abort: X2 }), t3();
    });
    return t3;
  }, getState: function(e2) {
    var n3 = ue2.getState();
    return e2 ? i$3(n3, e2) : Object.assign({}, n3);
  }, dispatch: function(e2) {
    var n3 = q$1(e2) ? { type: e2 } : e2;
    if (z.includes(n3.type))
      throw new Error("reserved action " + n3.type);
    var t3 = v({}, n3, { _: v({ originalAction: n3.type }, e2._ || {}) });
    ue2.dispatch(t3);
  }, enablePlugin: G2.enable, disablePlugin: G2.disable, plugins: G2, storage: { getItem: f$1.getItem, setItem: function(e2, n3, t3) {
    ue2.dispatch({ type: q.setItemStart, key: e2, value: n3, options: t3 });
  }, removeItem: function(e2, n3) {
    ue2.dispatch({ type: q.removeItemStart, key: e2, options: n3 });
  } }, setAnonymousId: function(e2, n3) {
    Q2.storage.setItem(A$1, e2, n3);
  }, events: { core: z, plugins: w2 } }, Y2 = s$1.middlewares.concat([function(e2) {
    return function(e3) {
      return function(n3) {
        return n3.meta || (n3.meta = Ve()), e3(n3);
      };
    };
  }, L2(Ce), se(Q2, x2, { all: _2, plugins: w2 }), le(f$1), C$1(Q2), B(Q2), L2(Re)]), Z2 = { context: je, user: R(f$1), page: _e, track: ve, plugins: de(x2), queue: be }, ee2 = N$1, ne2 = N$1;
  if ($$1 && n2.debug) {
    var te2 = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
    te2 && (ee2 = te2({ trace: true, traceLimit: 25 })), ne2 = function() {
      return 0 === arguments.length ? Me() : on(typeof arguments[0]) ? qe() : qe().apply(null, arguments);
    };
  }
  var re2, ie2 = function(e2) {
    return Object.keys(e2).reduce(function(n3, t3) {
      return ke.includes(t3) || (n3[t3] = e2[t3]), n3;
    }, {});
  }(n2), ae2 = s$1.pluginsArray.reduce(function(e2, n3) {
    var t3 = n3.name, r2 = n3.config, i2 = n3.loaded, a2 = s$1.pluginEnabled[t3];
    return e2[t3] = { enabled: a2, initialized: !!a2 && Boolean(!n3.initialize), loaded: Boolean(i2({ config: r2 })), config: r2 }, e2;
  }, {}), oe2 = { context: ie2, user: H2, plugins: ae2 }, ue2 = P(function(e2) {
    for (var n3 = Object.keys(e2), t3 = {}, r2 = 0; r2 < n3.length; r2++) {
      var i2 = n3[r2];
      typeof e2[i2] === y && (t3[i2] = e2[i2]);
    }
    var a2, o2 = Object.keys(t3);
    try {
      !function(e3) {
        Object.keys(e3).forEach(function(n4) {
          var t4 = e3[n4];
          if (typeof t4(void 0, { type: "@@redux/INIT" }) === b$1 || typeof t4(void 0, { type: I$1 }) === b$1)
            throw new Error("reducer " + n4 + " " + b$1);
        });
      }(t3);
    } catch (e3) {
      a2 = e3;
    }
    return function(e3, n4) {
      if (void 0 === e3 && (e3 = {}), a2)
        throw a2;
      for (var r3 = false, i3 = {}, u2 = 0; u2 < o2.length; u2++) {
        var c3 = o2[u2], s2 = e3[c3], l2 = (0, t3[c3])(s2, n4);
        if (typeof l2 === b$1) {
          var f2 = S(c3, n4);
          throw new Error(f2);
        }
        i3[c3] = l2, r3 = r3 || l2 !== s2;
      }
      return r3 ? i3 : e3;
    };
  }(v({}, Z2, t2)), oe2, ne2(ee2(O$1.apply(void 0, Y2))));
  ue2.dispatch = (re2 = ue2.dispatch, function(e2, n3, t3) {
    var r2 = v({}, e2, { meta: Ve(e2.meta, n3, Ue(t3)) });
    return re2.apply(null, [r2]);
  });
  var ce2 = Object.keys(h2);
  ue2.dispatch({ type: q.bootstrap, plugins: ce2, config: ie2, params: J2, user: H2, initialUser: c2, persistedUser: W2 });
  var pe2 = ce2.filter(function(e2) {
    return s$1.pluginEnabled[e2];
  }), me2 = ce2.filter(function(e2) {
    return !s$1.pluginEnabled[e2];
  });
  return ue2.dispatch({ type: q.registerPlugins, plugins: ce2, enabled: s$1.pluginEnabled }), s$1.pluginsArray.map(function(e2, n3) {
    var t3 = e2.bootstrap, r2 = e2.config, i2 = e2.name;
    t3 && W$1(t3) && t3({ instance: Q2, config: r2, payload: e2 }), ue2.dispatch({ type: q.registerPluginType(i2), name: i2, enabled: s$1.pluginEnabled[i2], plugin: e2 }), s$1.pluginsArray.length === n3 + 1 && ue2.dispatch({ type: q.initializeStart, plugins: pe2, disabled: me2 });
  }), ze(function(e2) {
    ue2.dispatch({ type: e2 ? q.offline : q.online });
  }), function(e2, n3, t3) {
    setInterval(function() {
      return F$1(e2, n3, t3);
    }, 3e3);
  }(ue2, x2, Q2), Q2;
}
var Ce = "before", Re = "after";
var t = "cookie", i$1 = a$1(), r$1 = d$1, c = d$1;
function u(o2) {
  return i$1 ? d$1(o2, "", -1) : i$2(o2);
}
function a$1() {
  if (void 0 !== i$1)
    return i$1;
  var e2 = "cookiecookie";
  try {
    d$1(e2, e2), i$1 = -1 !== document.cookie.indexOf(e2), u(e2);
  } catch (e3) {
    i$1 = false;
  }
  return i$1;
}
function d$1(e2, t2, r2, c2, u2, a2) {
  if ("undefined" != typeof window) {
    var d2 = arguments.length > 1;
    return false === i$1 && (d2 ? f(e2, t2) : a$2(e2)), d2 ? document.cookie = e2 + "=" + encodeURIComponent(t2) + (r2 ? "; expires=" + new Date(+/* @__PURE__ */ new Date() + 1e3 * r2).toUTCString() + (c2 ? "; path=" + c2 : "") + (u2 ? "; domain=" + u2 : "") + (a2 ? "; secure" : "") : "") : decodeURIComponent((("; " + document.cookie).split("; " + e2 + "=")[1] || "").split(";")[0]);
  }
}
var r = "localStorage", g = b$3.bind(null, "localStorage");
u$1("localStorage", "getItem", a$2);
u$1("localStorage", "setItem", f);
u$1("localStorage", "removeItem", i$2);
var a = "sessionStorage", i = b$3.bind(null, "sessionStorage");
u$1("sessionStorage", "getItem", a$2);
u$1("sessionStorage", "setItem", f);
u$1("sessionStorage", "removeItem", i$2);
function I(t2) {
  var o2 = t2;
  try {
    if ("true" === (o2 = JSON.parse(t2)))
      return true;
    if ("false" === o2)
      return false;
    if (on(o2))
      return o2;
    parseFloat(o2) === o2 && (o2 = parseFloat(o2));
  } catch (t3) {
  }
  if (null !== o2 && "" !== o2)
    return o2;
}
var k = g(), O = i(), x = a$1();
function C(o2, e2) {
  if (o2) {
    var r2 = A(e2), a2 = !N(r2), i2 = d(r2) ? I(localStorage.getItem(o2)) : void 0;
    if (a2 && !I$2(i2))
      return i2;
    var n2 = h(r2) ? I(r$1(o2)) : void 0;
    if (a2 && n2)
      return n2;
    var l2 = E(r2) ? I(sessionStorage.getItem(o2)) : void 0;
    if (a2 && l2)
      return l2;
    var u2 = a$2(o2);
    return a2 ? u2 : { localStorage: i2, sessionStorage: l2, cookie: n2, global: u2 };
  }
}
function L(r$2, a$12, l$1) {
  if (r$2 && !I$2(a$12)) {
    var u2 = {}, g2 = A(l$1), m2 = JSON.stringify(a$12), S2 = !N(g2);
    return d(g2) && (u2[r] = F(r, a$12, I(localStorage.getItem(r$2))), localStorage.setItem(r$2, m2), S2) ? u2[r] : h(g2) && (u2[t] = F(t, a$12, I(r$1(r$2))), c(r$2, m2), S2) ? u2[t] : E(g2) && (u2[a] = F(a, a$12, I(sessionStorage.getItem(r$2))), sessionStorage.setItem(r$2, m2), S2) ? u2[a] : (u2[l] = F(l, a$12, a$2(r$2)), f(r$2, a$12), S2 ? u2[l] : u2);
  }
}
function b(t$1, e2) {
  if (t$1) {
    var a$12 = A(e2), s2 = C(t$1, m), n2 = {};
    return !I$2(s2.localStorage) && d(a$12) && (localStorage.removeItem(t$1), n2[r] = s2.localStorage), !I$2(s2.cookie) && h(a$12) && (u(t$1), n2[t] = s2.cookie), !I$2(s2.sessionStorage) && E(a$12) && (sessionStorage.removeItem(t$1), n2[a] = s2.sessionStorage), !I$2(s2.global) && G(a$12, l) && (i$2(t$1), n2[l] = s2.global), n2;
  }
}
function A(t2) {
  return t2 ? q$1(t2) ? t2 : t2.storage : b$2;
}
function d(t2) {
  return k && G(t2, r);
}
function h(t$1) {
  return x && G(t$1, t);
}
function E(t2) {
  return O && G(t2, a);
}
function N(t2) {
  return t2 === m || "all" === t2;
}
function G(t2, o2) {
  return t2 === b$2 || t2 === o2 || N(t2);
}
function F(t2, o2, e2) {
  return { location: t2, current: o2, previous: e2 };
}
var J = { setItem: L, getItem: C, removeItem: b };
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = null != arguments[i2] ? arguments[i2] : {};
    i2 % 2 ? ownKeys(Object(source), true).forEach(function(key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function analyticsLib() {
  var opts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  var defaultSettings = {
    storage: J
  };
  return Le(_objectSpread2(_objectSpread2({}, defaultSettings), opts));
}
const analyticsTimeOnPage = () => ({
  name: "analytics-timeOnPage",
  page: ({ payload }) => {
    const pagePath = payload.properties.path;
    payload.properties = {
      ...payload.properties,
      ...timeOnPage("page", pagePath)
    };
  },
  track: ({ payload }) => {
    const pagePath = payload.properties.path || window.location.pathname;
    payload.properties = {
      ...payload.properties,
      ...timeOnPage("track", pagePath)
    };
  }
});
const analyticsVisitId = () => ({
  name: "analytics-visitId",
  page: ({ payload }) => {
    const ids = payload.properties.ids || {};
    const allIds = { ...ids, visit_id: getVisitId() };
    payload.properties = {
      ...payload.properties,
      ids: allIds
    };
  },
  track: ({ payload }) => {
    const ids = payload.properties.ids || {};
    const allIds = { ...ids, visit_id: getVisitId() };
    payload.properties = {
      ...payload.properties,
      ids: allIds
    };
  }
});
const checkLatestVersion = async (pkgJson, enableVersionChecker) => {
  if (enableVersionChecker === false) {
    return;
  }
  const isDevEnv = process.env.NODE_ENV === "development";
  const isLocalhost = typeof window !== "undefined" && (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1");
  if (isLocalhost || isDevEnv) {
    const { name, version } = pkgJson;
    if (!name || !version) {
      console.error("Missing name or version in checkUpdateBrowser");
      return;
    }
    const queryParams = new URLSearchParams({ name, version }).toString();
    const url = `https://ffn-cx-tooling-event-producer.dev.ffngcp.com/version-check?${queryParams}`;
    const headers = {
      accept: "application/vnd.npm.install-v1+json; q=1.0, application/json; q=0.8, */*"
    };
    try {
      const response = await fetch(url, { headers });
      if (!response.ok) {
        console.error(
          "@achieve/version-checker failed to fetch data",
          response
        );
      }
      const { latest, message } = await response.json();
      if (!latest) {
        console.warn(message);
      }
    } catch (error) {
      console.error(
        "@achieve/version-checker failed to check for updates",
        error
      );
    }
  }
};
checkLatestVersion(pkg);
const createAnalytics = ({
  application,
  plugins = [],
  logger: logger2 = console,
  ...options
}) => {
  setLogger(logger2);
  return analyticsLib({
    app: application,
    plugins: [
      originalSourcePlugin(),
      analyticsTimeOnPage(),
      analyticsMerkleIds(),
      analyticsVisitId(),
      ...plugins
    ],
    ...options
  });
};
export {
  createAnalytics as c,
  getVisitId as g
};
